export default {
  name: "Temporary Need Information",
  sections: [
    {
      fields: [
        {
          code: "B.1",
          machine_name: "tempneedJobtitle",
          widget: "text",
          label: "Job Title",
          validate: [
            "required",
            // {
            //   minLength: 10,
            //   message: "Please enter the full statement of need.",
            // },
          ],
          maxLength: 60,
          tooltip: `Enter the job title of the job opportunity for which the <i>H-2B Application for Temporary Employment Certification</i> 
            is being sought by the employer.  The entry in this field must be the same as the job title issued by the Department 
            for the employer’s job opportunity on the prevailing wage determination (PWD) Form ETA-9141.`,
        },
        {
          code: "B.2/3",
          machine_name: "tempneedSocTitle",
          widget: "text",
          label: "SOC Code and Occupation Title",
          // validate: ["required"],
          hidden: true,
        },
        {
          code: "B.2/3",
          machine_name: "tempneedSoc",
          widget: "soc",
          label: "SOC Code and Occupation Title",
          field_to_modify: "tempneedSocTitle",
          validate: ["required"],
          tooltip: `Enter the six or eight-digit Standard Occupational Classification (SOC) code for the occupation that most clearly describes 
            the work to be performed.  For example, the six-digit SOC code for a landscaping worker is 37-3011 
            (Landscaping and Groundskeeping Workers).  The entry in this field must be the same as the SOC code issued 
            by the Department for the employer’s job opportunity on the PWD Form ETA-9141.`,
        },
        {
          code: "B.4",
          machine_name: "tempneedWkrPos",
          widget: "text",
          label: "Number of Workers",
          clearSchema: [
            "employmentLocations.apdxaTotalWorkers",
            "registrationNumber",
          ],
          disabled: true,
          disableWhenField: (formValues) => !!formValues.registrationNumber,
          // addTableError: ["appx_a.appx_a_total_workers"],
          validate: [
            "required",
            "number",
            {
              fieldComparison: "tempneedWkrPos",
              message: "This number should be greater than or equal to 1.",
              needsFieldValues: true,
              extraData: {
                operator: ">=",
                valueOf: 1,
              },
            },
            {
              valueChecker: "tempneedWkrPos",
              message:
                "The estimated total for Section A must equal the number in Section B Item 4 at the time of filing this application.",
              needsFieldValues: true,
              extraData: {
                valueOf: "tempneedWkrPos",
                fields: ["capSubject", "capExempt"],
                check: "sumOfFields",
                operator: "=",
              },
            },
          ],
          maxLength: 4,
          parse: "positiveWholeNumber",
          tooltip:
            "Enter the total number of H-2B workers being requested for temporary labor certification.",
        },
        {
          isGroup: {
            fieldLevelErrors: true,
            showIndividualFieldError: true,
            fields: [
              {
                code: "B.5",
                machine_name: "tempneedStart",
                widget: "date",
                label: "Begin Date",
                maxDate: "tempneedEnd",
                clearSchema: [
                  "employmentLocations.apdxaBeginDate",
                  "registrationNumber",
                ],
                // addTableError: ["appx_a.appx_a_begin_date"],
                disabled: true,
                disableWhenField: (formValues) =>
                  !!formValues.registrationNumber,
                validate: [
                  "required",
                  {
                    dateStartCheck: "tempneedStart",
                    message:
                      "A completed Application for Temporary Employment Certification must be filed no more than 90 calendar days and no less than 75 calendar days before the employer's date of need",
                    needsFieldValues: true,
                    extraData: {
                      lessThanValue: 75,
                      greaterThanValue: 90,
                      emergencyField: "isEmergency", //F.b.11 field
                      emergencyLessThanValue: 0,
                      emergencyGreaterThanValue: 90,
                    },
                  },
                  {
                    dateStartEnd: "tempneedStart",
                    message: "Begin Date must occur before End Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "start",
                    },
                  },
                ],
                tooltip:
                  "Enter the begin date for the period of employment for the worker(s) requested.  Use a month/day/year (mm/dd/yyyy) format.",
              },
              {
                code: "B.6",
                machine_name: "tempneedEnd",
                widget: "date",
                label: "End Date",
                minDate: "tempneedStart",
                clearSchema: [
                  "employmentLocations.apdxaEndDate",
                  "registrationNumber",
                ],
                // addTableError: ["appx_a.appx_a_end_date"],
                warning: {
                  text: `The period of employment appears to be approximately 10 months or longer which, depending on the circumstances 
                  of the job opportunity, may require additional information to ensure the OFLC Certifying Officer that the 
                  employer’s need for the agricultural services or labor to be performed is temporary or seasonal nature. 
                  20 CFR 655.103(d).  Employment is of a seasonal nature where it is tied to a certain time of year by an 
                  event or pattern, such as a short annual growing cycle or a specific aspect of a longer cycle, and requires 
                  labor levels far above those necessary for ongoing operations. Employment is of a temporary nature where 
                  the employer's need to fill the position with a temporary worker will, except in extraordinary circumstances, 
                  last no longer than 1 year.`,
                  isVisible: {
                    when: "tempneedEnd tempneedStart",
                    operator: "compareMultiDateValues",
                    is: {
                      operator: ">=",
                      type: "months",
                      value: "10",
                    },
                  },
                },
                disabled: true,
                disableWhenField: (formValues) =>
                  !!formValues.registrationNumber,
                validate: [
                  "required",
                  {
                    dateStartEnd: "tempneedStart",
                    message: "End Date must occur after Begin Date.",
                    needsFieldValues: true,
                    extraData: {
                      type: "end",
                    },
                  },
                ],
                tooltip:
                  "Enter the end date for the period of employment for the worker(s) requested.  Use a month/day/year (mm/dd/yyyy) format.",
              },
            ],
          },
        },
        {
          isGroup: {
            code: "B.7",
            label: "Nature of Temporary Need",
            machine_name: "tempneedNature",
            tooltip: `Mark the appropriate box to indicate the nature of the employer’s temporary need for the services or labor to be performed.  
              Only one standard of temporary need may be selected.  For more information concerning the definitions of each standard of 
              temporary need, please visit the Department of Homeland Security’s USCIS web site at <a target="_blank" href="https://www.uscis.gov">www.uscis.gov</a>.`,
            coloring: "none",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Seasonal",
                value: "Seasonal",
                disabled: true,
                disableWhenField: (formValues) =>
                  !!formValues.registrationNumber,
                validate: ["required"],
                clearSchema: ["registrationNumber"],
              },
              {
                widget: "radio",
                choice: "Peakload",
                value: "Peakload",
                disabled: true,
                disableWhenField: (formValues) =>
                  !!formValues.registrationNumber,
                validate: ["required"],
                clearSchema: ["registrationNumber"],
              },
              {
                widget: "radio",
                choice: "One-Time Occurrence",
                value: "One-Time Occurrence",
                disabled: true,
                disableWhenField: (formValues) =>
                  !!formValues.registrationNumber,
                validate: ["required"],
                clearSchema: ["registrationNumber"],
              },
              {
                widget: "radio",
                choice: "Intermittent",
                value: "Intermittent",
                disabled: true,
                disableWhenField: (formValues) =>
                  !!formValues.registrationNumber,
                validate: ["required"],
                clearSchema: ["registrationNumber"],
              },
            ],
          },
        },
        {
          isGroup: {
            label: "Do you have an H-2B Registration Number",
            machine_name: "isRegistrationNumberLinked",
            coloring: "none",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
                clearSchema: ["tempneedDescription"],
                clearFiles: ["tempneedDoc"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
                clearSchema: ["registrationNumber"],
              },
            ],
          },
        },
      ],
    },

    {
      isVisible: {
        when: "isRegistrationNumberLinked",
        operator: "compareMultiFieldValuesAND_ORInArray",
        is: ["Yes"],
      },
      coloring: "blue",
      fields: [
        {
          code: "B.8",
          machine_name: "registrationNumber",
          widget: "registration_number_linking",
          linkingSchema: {
            formId: "9142B",
            rnLinkingDataField: "rnLinkingData",
            allowOutOfNetwork: true,
            sortingFields: [
              "empFein",
              "jobMsa",
              "tempneedNature",
              "tempneedWkrPos",
              "tempneedStart",
              "tempneedEnd",
            ],
            modalScreens: {
              startingScreen: "SELECTION_SCREEN",
              all: [
                "SELECTION_SCREEN",
                "ACKNOWLEDGEMENT_SCREEN", // Put screens in the order in which you wish them to show
              ],
            },
          },
          toEnable: `You must complete the following fields before linking an H-2B Temporary Need Registration Number: Number of Workers (B.4), Begin Date (B.5), End Date (B.6), Nature of Temporary Need (B.7), FEIN (C.12), and Primary Worksite MSA (F.b.7)`,
          disabled: true,
          disableWhenField: [
            {
              when: "empFein",
              is: null,
            },
            {
              when: "jobMsa",
              is: null,
            },
            {
              when: "tempneedNature",
              is: null,
            },
            {
              when: "tempneedWkrPos",
              is: "",
            },
            {
              when: "tempneedStart",
              is: null,
            },
            {
              when: "tempneedEnd",
              is: null,
            },
          ],
          label: "Statement of Temporary Need",
          validate: ["required"],
        },
      ],
    },
    {
      isVisible: {
        when: "isRegistrationNumberLinked",
        operator: "compareMultiFieldValuesAND_ORInArray",
        is: ["No"],
      },
      fields: [
        {
          code: "B.8",
          machine_name: "tempneedDescription",
          widget: "text_area",
          label: "Statement of Temporary Need",
          validate: [
            "required",
            {
              minLength: 10,
              message: "Please enter the full statement of need.",
            },
          ],
          message: "This field cannot be more than 4000 characters long.",
          tooltip: `Provide a brief statement clearly describing the employer’s temporary need for the services or labor to be performed.  
          The employer’s statement must explain (a) the nature of the employer’s business or operations; (b) why the job opportunity, 
          period of employment, and number of workers being requested for certification reflect a temporary need; and (c) how the 
          employer’s request for the services or labor to be performed meets the chosen standard under Question 7 of a seasonal, 
          peakload, one-time occurrence, or an intermittent basis.  If the period of employment (e.g., begin date of work) 
          and/or number of workers have changed from previous filings, please briefly explain the circumstances or reason(s) for the change.
          <br/><br/>The brief statement of temporary need must be provided in the space allotted on the form.  The employer may 
          include one separate attachment where the allotted space is insufficient to fully respond to this collection item.  
          For employers filing electronically, the Department’s electronic filing system will automatically provide the employer 
          with an addendum if the entry exceeds the allotted space on the form.  For employers filing applications by mail, 
          the employer must begin its statement of temporary need in the allotted space and include one clearly-marked and 
          easy-to-locate separate attachment, if necessary, to fully respond to this collection item.
          <br/><br/>Separate attachments will not be accepted.  Other documentation or evidence demonstrating temporary need (e.g., 
          summarized monthly payroll records, monthly invoices, occupancy charts, work contracts) is not required to be filed 
          with the H-2B application.  Instead, it must be retained by the employer and provided to the Department in the event 
          a Notice of Deficiency (NOD) is issued by the Office of Foreign Labor Certification (OFLC) Certifying Officer.`,
          rows: 8,
          placeholder: "",
          inputLimit: 4000,
        },
        {
          isGroup: {
            code: "B.8",
            machine_name: "tempneedDoc",
            label: `The brief statement of temporary need must be provided in the space above, however, you may include one separate attachment where the allotted space is insufficient.`,
            coloring: "none",
            fields: [
              {
                label: `Document Upload - Temporary Need`,
                labelHidden: true,
                code: "B.8",
                machine_name: "tempneedDoc",
                name: "Temporary Need",
                widget: "file_upload",
                accept_multiple: false,
                fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
                description: `B.8: The brief statement of temporary need must be provided in the space above, however, you may include one separate attachment where the allotted space is insufficient.`,
              },
            ],
          },
        },
      ],
    },
  ],
};
